import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'
import { useCallback, useMemo, useState } from 'react'

export interface TripsFilterValues extends FilterValues {
  keywords: string[]
  status: string[]
  fromDate?: Date
  toDate?: Date
  branches: string[]
}

interface TripsViewContextExtension {
  predefinedFilter: string | null
  setPredefinedFilter: (filter: string) => void
}

const defaultFilters: TripsFilterValues = {
  keywords: [],
  status: ['DELIVERED', 'IN_PROGRESS', 'NEW', 'TRIP_ASSIGNED'],
  branches: [],
}

const useTripsViewContextExtension = (): TripsViewContextExtension => {
  const [predefinedFilter, setPredefinedFilter] = useState<string | null>(null)

  const setPredefinedFilterAction = useCallback((filter: string): void => {
    setPredefinedFilter((currentFilter) => currentFilter !== filter ? filter : null)
  }, [])

  return useMemo(() => ({
    predefinedFilter,
    setPredefinedFilter: setPredefinedFilterAction,
  }), [predefinedFilter, setPredefinedFilterAction])
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters, useTripsViewContextExtension)

export { ListViewProvider as TripsViewProvider, useListView as useTripsView }
